// extracted by mini-css-extract-plugin
export default {"SeeMoreBtn":"HorizontalBooksSections_SeeMoreBtn__EF6Gt"};